module.exports = __webpack_public_path__ + "static/media/TeamWork2K01.27483f4f.png";